import $ from "jquery";

const jobStoreFinderHelper = {
    encodeXml(string) {
        var xml_special_to_escaped_one_map = {
            '&': '&amp;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;'
        };

        return string.replace(/([\&"<>])/g, function (str, item) {
            return xml_special_to_escaped_one_map[item];
        });
    },
    decodeXml(string) {
        var escaped_one_to_xml_special_map = {
            '&amp;': '&',
            '&quot;': '"',
            '&lt;': '<',
            '&gt;': '>'
        };
        return string.replace(/(&quot;|&lt;|&gt;|&amp;)/g,
            function (str, item) {
                return escaped_one_to_xml_special_map[item];
            });
    },
    getCountryIsoCode(string) {
        var country = {
            '10122': 'AT',
            '13670': 'BG',
            '10220': 'DE',
            '10577': 'HR',
            '10579': 'RO',
            '10580': 'SK',
            '10241': 'SI',
            '10576': 'CZ',
            '10524': 'HU',
        };
        return country[string];
    },
    sortSelectOptions(selector, skip_first) {
        var options = (skip_first) ? $(selector + ' option:not(:first)') : $(selector + ' option');
        var arr = options.map(function (_, o) {
            return {t: $(o).text(), v: o.value, s: $(o).prop('selected'), c: $(o).attr('class')};
        }).get();
        arr.sort(function (o1, o2) {
            var t1 = o1.t.toLowerCase(), t2 = o2.t.toLowerCase();
            return t1 > t2 ? 1 : t1 < t2 ? -1 : 0;
        });
        options.each(function (i, o) {
            o.value = arr[i].v;
            $(o).text(arr[i].t);
            $(o).attr('class', arr[i].c);
            if (arr[i].s) {
                $(o).attr('selected', 'selected').prop('selected', true);
            } else {
                $(o).removeAttr('selected');
                $(o).prop('selected', false);
            }
        });
    },
    sortCities (cityArr) {
        cityArr.sort(function (o1, o2) {
            var t1 = o1.cityText.toLowerCase(), t2 = o2.cityText.toLowerCase();
            return t1 > t2 ? 1 : t1 < t2 ? -1 : 0;
        });
    }
};

export default jobStoreFinderHelper;
